/**
 * i18n.js
 *
 * This will setup the i18n language files and locale data for your app.
 *
 *   IMPORTANT: This file is used by the internal build
 *   script `i18n:update`, and must use CommonJS module syntax
 *   You CANNOT use import/export in this file.
 */

require('./i18n.polyfills');

const enTranslationMessages = require('./translations/en.json');
const esTranslationMessages = require('./translations/es.json');
const frTranslationMessages = require('./translations/fr.json');
const deTranslationMessages = require('./translations/de.json');
const itTranslationMessages = require('./translations/it.json');
const frCATranslationMessages = require('./translations/fr-CA.json');
const jaTranslationMessages = require('./translations/ja-JP.json');
const ukUATranslationMessages = require('./translations/uk-UA.json');
const mlINTranslationMessages = require('./translations/ml-IN.json');
const tlPHTranslationMessages = require('./translations/tl-PH.json');

const DEFAULT_LOCALE = 'en';

// prettier-ignore
const appLocales = [
  'en',
  'es',
  'fr',
  'de',
  'it',
  'fr-CA',
  'ja',
  'uk-UA',
  'ml-IN',
  'tl-PH',
];

const formatTranslationMessages = (locale, messages) => {
  const defaultFormattedMessages =
    locale !== DEFAULT_LOCALE
      ? formatTranslationMessages(DEFAULT_LOCALE, enTranslationMessages)
      : {};
  const flattenFormattedMessages = (formattedMessages, key) => {
    const formattedMessage =
      !messages[key] && locale !== DEFAULT_LOCALE
        ? defaultFormattedMessages[key]
        : messages[key];
    return Object.assign(formattedMessages, { [key]: formattedMessage });
  };
  return Object.keys(messages).reduce(flattenFormattedMessages, {});
};

const translationMessages = {
  'en-US': formatTranslationMessages('en', enTranslationMessages),
  'en-GB': formatTranslationMessages('en', enTranslationMessages),
  es: formatTranslationMessages('es', esTranslationMessages),
  fr: formatTranslationMessages('fr', frTranslationMessages),
  de: formatTranslationMessages('de', deTranslationMessages),
  it: formatTranslationMessages('it', itTranslationMessages),
  'fr-CA': formatTranslationMessages('fr-CA', frCATranslationMessages),
  ja: formatTranslationMessages('ja', jaTranslationMessages),
  'uk-UA': formatTranslationMessages('uk-UA', ukUATranslationMessages),
  'ml-IN': formatTranslationMessages('ml-IN', mlINTranslationMessages),
  'tl-PH': formatTranslationMessages('tl-PH', tlPHTranslationMessages),
};

exports.appLocales = appLocales;
exports.formatTranslationMessages = formatTranslationMessages;
exports.translationMessages = translationMessages;
exports.DEFAULT_LOCALE = DEFAULT_LOCALE;
